import type { FC } from "react";
import { Flex, Text } from "@huub-web/ui";
import { useTranslation } from "react-i18next";

import type { AuthLegalLink } from "../../../types";

export type LegalLinksProps = {
  /**
   * Legal links to display (e.g. privacy statement, terms)
   */
  links: AuthLegalLink[];
  /**
   * i18n key of a statutory notice shown under the links
   * (e.g. the identification of the licence holder)
   */
  notice?: string;
};

/**
 * Renders a row of tenant-specific legal links, with an optional statutory
 * notice underneath. Renders nothing when there is neither.
 */
export const LegalLinks: FC<LegalLinksProps> = ({ links, notice }) => {
  const { t } = useTranslation();

  if (links.length === 0 && !notice) return null;

  return (
    <Flex direction="column" gap="xs" align="center">
      {links.length > 0 && (
        <Flex direction="row" gap="s" justify="center" wrap>
          {links.map((link) => (
            <Text key={link.labelKey} variant="bodyS" color="currentColor50">
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {t(link.labelKey)}
              </a>
            </Text>
          ))}
        </Flex>
      )}
      {notice && (
        <Text variant="bodyXS" color="currentColor50" align="center">
          {t(notice)}
        </Text>
      )}
    </Flex>
  );
};
